import { render, staticRenderFns } from "./VueFooter.vue?vue&type=template&id=fcdb59f8&scoped=true&"
import script from "./VueFooter.vue?vue&type=script&lang=js&"
export * from "./VueFooter.vue?vue&type=script&lang=js&"
import style0 from "./VueFooter.vue?vue&type=style&index=0&id=fcdb59f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdb59f8",
  null
  
)

component.options.__file = "VueFooter.vue"
export default component.exports